<template>
  <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
    <div>
      <div
        style="padding: 10px;background: #fff;text-align: left;font-size:1.1rem;text-align: center;font-weight: 700;color: #00b8ff;"
      >
        跑兔体育出场名单填写
      </div>
      <div
        style="text-align: center;padding: 10px;font-size: 19px;font-weight: 600;"
      >
        {{ SSMC }}
      </div>
      <van-tabs type="card" @click="fitterResultList" v-model="active">
        <van-tab title="待填写" name="0"></van-tab>
        <van-tab title="已填写" name="1"></van-tab>
      </van-tabs>
      <div ref="captureArea" class="content">
        <div
          v-for="(mainItem, mainIndex) in resultList"
          :key="mainIndex"
          style="margin-top:36px;"
        >
          <van-row>
            <van-col span="24">
              <div
                style="background: #E2EFDA;font-size: 16px;font-weight: 700;height: 52px;line-height: 52px;text-align: center;"
              >
                {{ mainItem.MXLIST[0].XMJC }}（{{ mainItem.MXLIST[0].SSLXMC }}）
                {{ mainItem.MXLIST[0].TITLE }}
              </div>
            </van-col>
          </van-row>
          <van-row>
            <van-col span="24">
              <div
                style="padding: 16px;background: #fff;color:blue;border-bottom: 1px solid #ebedf0;font-weight: 700;"
              >
                {{ mainItem.MXLIST[0].XMQC }} (共{{
                  mainItem.MXLIST.length
                }}个项目)
              </div>
            </van-col>
          </van-row>
          <van-cell style="padding:0px">
            <van-row>
              <van-col span="9">
                <div
                  style="padding: 16px;background: #fff;font-size: 15px;font-weight: 700;text-align: center;"
                >
                  {{ mainItem.MXLIST[0].RYXM1 }}({{
                    mainItem.MXLIST[0].SSZL == "XH"
                      ? mainItem.MXLIST[0].ZHID + mainItem.MXLIST[0].ZNWZH1
                      : mainItem.MXLIST[0].ZNWZH1
                  }})
                </div>
              </van-col>
              <van-col span="6">
                <div
                  style="padding: 16px;background: #fff;font-size: 15px;font-weight: 700;"
                >
                  VS
                </div>
              </van-col>
              <van-col span="9">
                <div
                  style="padding: 16px;background: #fff;font-size: 15px;font-weight: 700;text-align: center;"
                >
                  {{ mainItem.MXLIST[0].RYXM2 }}({{
                    mainItem.MXLIST[0].SSZL == "XH"
                      ? mainItem.MXLIST[0].ZHID + mainItem.MXLIST[0].ZNWZH2
                      : mainItem.MXLIST[0].ZNWZH2
                  }})
                </div>
              </van-col>
            </van-row>
          </van-cell>
          <div style="background: #fff;" v-if="ISWRITEFZYS === '1'">
            <van-row>
              <van-col :span="12">
                <div
                  style="text-align: center;height: 50px;padding: 15px;"
                  @click="
                    openFzysModal(mainItem.MXLIST[0].WHOWRITE, mainItem, 'L')
                  "
                >
                  <div
                    style="background: #666666;line-height: 50px;border-radius: 6px;
                  color: #fff;
                  font-weight: 700;font-size: 16px;"
                  >
                    {{
                      mainItem.MXLIST[0].WHOWRITE === "L"
                        ? mainItem.MXLIST[0].FZYS1.length === 0
                          ? "请选择服装颜色"
                          : mainItem.MXLIST[0].FZYS1
                        : mainItem.MXLIST[0].FZYS1.length === 0
                        ? "未选择"
                        : mainItem.MXLIST[0].FZYS1
                    }}
                  </div>
                </div>
              </van-col>
              <van-col :span="12">
                <div
                  style="text-align: center;height: 50px;padding:15px;"
                  @click="
                    openFzysModal(mainItem.MXLIST[0].WHOWRITE, mainItem, 'R')
                  "
                >
                  <div
                    style="background: #666666;line-height: 50px;border-radius: 6px;
                  color: #fff;
                  font-weight: 700;font-size: 16px;"
                  >
                    {{
                      mainItem.MXLIST[0].WHOWRITE === "R"
                        ? mainItem.MXLIST[0].FZYS2.length === 0
                          ? "请选择服装颜色"
                          : mainItem.MXLIST[0].FZYS2
                        : mainItem.MXLIST[0].FZYS2.length === 0
                        ? "未选择"
                        : mainItem.MXLIST[0].FZYS2
                    }}
                  </div>
                </div>
              </van-col>
            </van-row>
          </div>
          <div
            v-if="
              (mainItem.MXLIST[0].WHOWRITE === 'L' &&
                mainItem.MXLIST[0].FZYS1.length > 0) ||
                (mainItem.MXLIST[0].WHOWRITE === 'R' &&
                  mainItem.MXLIST[0].FZYS2.length > 0) ||
                ISWRITEFZYS === '0' ||
                mainItem.MXLIST[0].WHOWRITE === 'success'
            "
          >
            <div
              v-for="(mxItem, mxIndex) in mainItem.MXLIST"
              :key="mxIndex"
              style="border-top: 5px dashed #011887;"
            >
              <van-cell style="padding:0px">
                <van-row>
                  <van-col span="9">
                    <div
                      style="padding: 16px;background: #fff;font-size: 15px;font-weight: 700;"
                    >
                      项目：{{
                        mxItem.XMBM.length === 0
                          ? mxItem.TEAMSSLXMC
                          : mxItem.XMBM
                      }}
                    </div>
                  </van-col>
                  <van-col span="6">
                    <div
                      style="padding: 16px;background: #fff;font-size: 15px;font-weight: 700;"
                    >
                      第{{ mxItem.SXH }}场
                    </div>
                  </van-col>
                  <van-col span="9">
                    <div
                      style="padding: 16px;background: #fff;font-size: 15px;font-weight: 700;"
                    >
                      <div>
                        {{ mxItem.RQ }}
                      </div>
                      <div>
                        {{ mxItem.STARTTIME }}
                      </div>
                    </div>
                  </van-col>
                </van-row>
              </van-cell>

              <van-cell style="padding:0px" v-if="mxItem.AGEMSG.length > 0">
                <van-row>
                  <van-col span="24">
                    <div
                      style="padding: 14px;background: #fff;font-size: 15px;color:#aa0000"
                    >
                      {{ mxItem.AGEMSG }}
                    </div>
                  </van-col>
                </van-row>
              </van-cell>

              <van-cell style="padding:0px;">
                <van-row>
                  <van-col span="12">
                    <div style="text-align: center;">
                      <div
                        v-if="mxItem.WHOWRITE === 'R' || mxItem.LQRMDCOUNT1 > 0"
                        style="padding-top: 15px;font-size: 15px;font-weight: 700;"
                      >
                        {{ mxItem.TEAMRYXM1 }}
                      </div>
                      <div
                        v-if="mxItem.WHOWRITE === 'R' || mxItem.LQRMDCOUNT1 > 0"
                        style="padding-bottom: 15px;font-size: 15px;font-weight: 700;"
                      >
                        {{ mxItem.TEAMRYXM2 }}
                      </div>
                      <div
                        v-if="
                          mxItem.WHOWRITE === 'L' && mxItem.LQRMDCOUNT1 === 0
                        "
                        v-bind:style="{
                          background:
                            mxItem.TEAMRYID1.length === 0
                              ? '#6c6c6c'
                              : '#046c04',
                          marginLeft: '1.6rem',
                          marginRight: '1.6rem',
                          padding: '8px',
                          color: '#fff',
                          fontSize: '15px',
                          fontWeight: '600',
                          borderRadius: '5px',
                          marginTop: '6px'
                        }"
                        @click="
                          openSelectRmdHandler(
                            mxItem,
                            mainItem.MXLIST,
                            'L',
                            mainItem.TEAMRMDLIST1,
                            1
                          )
                        "
                      >
                        {{
                          mxItem.TEAMRYID1.length === 0
                            ? "请选择"
                            : mxItem.TEAMRYXM1
                        }}
                        <van-icon name="arrow-down" />
                      </div>
                      <!-- v-if="mxItem.WHOWRITE === 'L' && mxItem.LQRMDCOUNT1 === 0" -->
                      <!-- <van-dropdown-menu v-if="false">
                      <van-dropdown-item
                        v-model="mxItem.TEAMRYID1"
                        :options="mainItem.TEAMRMDLIST1"
                        @change="
                          dropDownChange(
                            mxItem,
                            mainItem.MXLIST,
                            'L',
                            mainItem.TEAMRMDLIST1
                          )
                        "
                        @open="openDrop"
                      />
                    </van-dropdown-menu> -->
                    </div>
                    <div style="text-align: center;">
                      <div
                        v-if="
                          mxItem.WHOWRITE === 'L' &&
                            mxItem.LQRMDCOUNT1 === 0 &&
                            (mxItem.TEAMSSLX === 'MD' ||
                              mxItem.TEAMSSLX === 'WD' ||
                              mxItem.TEAMSSLX === 'XD' ||
                              mxItem.TEAMSSLX === 'SD')
                        "
                        v-bind:style="{
                          background:
                            mxItem.TEAMRYID2.length === 0
                              ? '#6c6c6c'
                              : '#046c04',
                          marginLeft: '1.6rem',
                          marginRight: '1.6rem',
                          padding: '8px',
                          color: '#fff',
                          fontSize: '15px',
                          fontWeight: '600',
                          borderRadius: '5px',
                          marginTop: '6px'
                        }"
                        @click="
                          openSelectRmdHandler(
                            mxItem,
                            mainItem.MXLIST,
                            'L',
                            mainItem.TEAMRMDLIST1,
                            2
                          )
                        "
                      >
                        {{
                          mxItem.TEAMRYID2.length === 0
                            ? "请选择"
                            : mxItem.TEAMRYXM2
                        }}
                        <van-icon name="arrow-down" />
                      </div>
                      <!-- <van-dropdown-menu
                      v-if="
                        mxItem.WHOWRITE === 'L' &&
                          mxItem.LQRMDCOUNT1 === 0 &&
                          (mxItem.TEAMSSLX === 'MD' ||
                            mxItem.TEAMSSLX === 'WD' ||
                            mxItem.TEAMSSLX === 'XD' ||
                            mxItem.TEAMSSLX === 'SD')
                      "
                    >
                      <van-dropdown-item
                        v-model="mxItem.TEAMRYID2"
                        :options="mainItem.TEAMRMDLIST1"
                        @change="
                          dropDownChange(
                            mxItem,
                            mainItem.MXLIST,
                            'L',
                            mainItem.TEAMRMDLIST1
                          )
                        "
                      />
                    </van-dropdown-menu> -->
                    </div>
                  </van-col>
                  <van-col span="12">
                    <div style="text-align: center;">
                      <div
                        v-if="mxItem.WHOWRITE === 'L' || mxItem.LQRMDCOUNT2 > 0"
                        style="padding-top: 15px;font-size: 15px;font-weight: 700;"
                      >
                        {{ mxItem.TEAMRYXM3 }}
                      </div>
                      <div
                        v-if="mxItem.WHOWRITE === 'L' || mxItem.LQRMDCOUNT2 > 0"
                        style="padding-bottom: 15px;font-size: 15px;font-weight: 700;"
                      >
                        {{ mxItem.TEAMRYXM4 }}
                      </div>
                      <div
                        v-if="
                          mxItem.WHOWRITE === 'R' && mxItem.LQRMDCOUNT2 === 0
                        "
                        v-bind:style="{
                          background:
                            mxItem.TEAMRYID3.length === 0
                              ? '#6c6c6c'
                              : '#046c04',
                          marginLeft: '1.6rem',
                          marginRight: '1.6rem',
                          padding: '8px',
                          color: '#fff',
                          fontSize: '15px',
                          fontWeight: '600',
                          borderRadius: '5px',
                          marginTop: '6px'
                        }"
                        @click="
                          openSelectRmdHandler(
                            mxItem,
                            mainItem.MXLIST,
                            'R',
                            mainItem.TEAMRMDLIST2,
                            3
                          )
                        "
                      >
                        {{
                          mxItem.TEAMRYID3.length === 0
                            ? "请选择"
                            : mxItem.TEAMRYXM3
                        }}
                        <van-icon name="arrow-down" />
                      </div>
                      <!-- <van-dropdown-menu
                      v-if="mxItem.WHOWRITE === 'R' && mxItem.LQRMDCOUNT2 === 0"
                    >
                      <van-dropdown-item
                        v-model="mxItem.TEAMRYID3"
                        :options="mainItem.TEAMRMDLIST2"
                        @change="
                          dropDownChange(
                            mxItem,
                            mainItem.MXLIST,
                            'R',
                            mainItem.TEAMRMDLIST2
                          )
                        "
                      />
                    </van-dropdown-menu> -->
                    </div>
                    <div style="text-align: center;">
                      <div
                        v-if="
                          mxItem.WHOWRITE === 'R' &&
                            mxItem.LQRMDCOUNT2 === 0 &&
                            (mxItem.TEAMSSLX === 'MD' ||
                              mxItem.TEAMSSLX === 'WD' ||
                              mxItem.TEAMSSLX === 'XD' ||
                              mxItem.TEAMSSLX === 'SD')
                        "
                        v-bind:style="{
                          background:
                            mxItem.TEAMRYID4.length === 0
                              ? '#6c6c6c'
                              : '#046c04',
                          marginLeft: '1.6rem',
                          marginRight: '1.6rem',
                          padding: '8px',
                          color: '#fff',
                          fontSize: '15px',
                          fontWeight: '600',
                          borderRadius: '5px',
                          marginTop: '6px'
                        }"
                        @click="
                          openSelectRmdHandler(
                            mxItem,
                            mainItem.MXLIST,
                            'R',
                            mainItem.TEAMRMDLIST2,
                            4
                          )
                        "
                      >
                        {{
                          mxItem.TEAMRYID4.length === 0
                            ? "请选择"
                            : mxItem.TEAMRYXM4
                        }}
                        <van-icon name="arrow-down" />
                      </div>
                      <!-- <van-dropdown-menu
                      v-if="
                        mxItem.WHOWRITE === 'R' &&
                          mxItem.LQRMDCOUNT2 === 0 &&
                          (mxItem.TEAMSSLX === 'MD' ||
                            mxItem.TEAMSSLX === 'WD' ||
                            mxItem.TEAMSSLX === 'XD' ||
                            mxItem.TEAMSSLX === 'SD')
                      "
                    >
                      <van-dropdown-item
                        v-model="mxItem.TEAMRYID4"
                        :options="mainItem.TEAMRMDLIST2"
                        @change="
                          dropDownChange(
                            mxItem,
                            mainItem.MXLIST,
                            'R',
                            mainItem.TEAMRMDLIST2
                          )
                        "
                      />
                    </van-dropdown-menu> -->
                    </div>
                  </van-col>
                </van-row>
              </van-cell>

              <van-cell style="padding:0px">
                <van-row>
                  <van-col span="24">
                    <div
                      style="padding: 14px;background: #fff;font-size: 15px;"
                    >
                      场地号：{{ mxItem.CDH }}号场地
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;场序号：{{ mxItem.CXH }}
                    </div>
                  </van-col>
                </van-row>
              </van-cell>
            </div>
          </div>
          <van-cell
            style="padding:0px"
            v-if="
              (mainItem.MXLIST[0].WHOWRITE === 'L' &&
                mainItem.MXLIST[0].LQRMDCOUNT1 === 0) ||
                (mainItem.MXLIST[0].WHOWRITE === 'R' &&
                  mainItem.MXLIST[0].LQRMDCOUNT2 === 0)
            "
          >
            <van-row>
              <van-col span="24">
                <van-button
                  type="primary"
                  block
                  @click="
                    writeRmdSave(
                      mainItem.MXLIST,
                      mainItem.MXLIST[0].WHOWRITE,
                      mainItem.CCH
                    )
                  "
                  >提交</van-button
                >
                <!-- <van-button type="primary" block @click="generateImage"
                  >提交</van-button
                > -->
              </van-col>
            </van-row>
          </van-cell>

          <!-- ((mainItem.MXLIST[0].WHOWRITE === 'L' &&
              mainItem.MXLIST[0].LQRMDCOUNT1 > 0) ||
              (mainItem.MXLIST[0].WHOWRITE === 'R' &&
                mainItem.MXLIST[0].LQRMDCOUNT2 > 0)) &&
              mainItem.MXLIST[0].ISSDLQ1 === '0' &&
              mainItem.MXLIST[0].ISSDLQ2 === '0' -->
          <van-cell style="padding:0px" v-if="false">
            <van-row>
              <van-col span="24">
                <van-button
                  type="danger"
                  block
                  @click="
                    writeRmdSave(
                      mainItem.MXLIST,
                      mainItem.MXLIST[0].WHOWRITE,
                      mainItem.CCH
                    )
                  "
                  >删除重填</van-button
                >
              </van-col>
            </van-row>
          </van-cell>
        </div>
      </div>
      <div style="height:100px;width:15px;"></div>
      <van-empty
        description="不存在待填名单的比赛"
        v-if="resultList.length === 0"
      />
    </div>
    <loading-com />

    <!-- 请选择服装颜色 -->
    <van-action-sheet
      v-model="fzysIsShow"
      :actions="FZYSLIST"
      @select="onSelectFzys"
    />

    <!-- 填写出场名单  开始 -->
    <van-action-sheet v-model="selectRmdModel.isShow" title="请选择人名单">
      <div class="content">
        <!-- {{ selectRmdModel.TEAMRMDLIST }} -->
        <!-- {{ selectRmdModel.MXITEM }} -->
        <van-cell
          v-for="(item, index) in selectRmdModel.TEAMRMDLIST"
          :key="index"
          :title="item.text"
          icon="friends"
          :value="item.msg"
          @click="dropDownChange(item.value, item.text)"
          is-link
        />
      </div>
      <div style="width:15px;height:100px;"></div>
    </van-action-sheet>
    <!-- 填写出场名单  结束 -->

    <!-- 图片预览弹窗 -->
    <van-image-preview
      v-model="showOverlay"
      :images="[imageUrl]"
      :closeable="false"
      :close-on-popstate="false"
      @close="handleClose"
    >
      <template #cover>
        <div class="preview-cover" @click.stop>
          <van-button
            style="position: fixed; bottom: 0px; left: 0px; right: 15px; z-index: 9999;"
            type="danger"
            block
            @click.stop="handleCloseClick"
          >
            长按图片，可保存到相册中，保存完毕后，点击可关闭
          </van-button>
        </div>
      </template>
    </van-image-preview>
  </van-pull-refresh>
</template>

<script>
import LoadingCom from "../commonCom/LoadingCom.vue";
import { Dialog } from "vant";
import html2canvas from "html2canvas";
export default {
  components: { LoadingCom },
  name: "WriteTeamRym",
  data() {
    return {
      showOverlay: false,
      imageUrl: "",
      tabType: "0",
      resultList: [],
      ssid: "",
      dwid: "",
      isWriteRmd: "1",
      utilPost: "",
      isLoading: false,
      resultListAll: [],
      active: "0",
      fzysIsShow: false,
      FZYSLIST: [],
      FZYS1: "",
      FZYS2: "",
      setValueItem: {},
      ISWRITEFZYS: "0",
      RMDTXFS: "",
      USERDE: "",
      selectRmdModel: {
        isShow: false,
        MXITEM: {},
        MXLIST: [],
        TYPE: "",
        TEAMRMDLIST: [],
        ryidIndex: 0
      },
      SSMC: "",
      saveResModel: {
        MXLIST: [],
        WHOWRITE: "",
        CCH: ""
      }
      //xmid: ""
    };
  },
  created() {
    this.ssid = this.$route.query.ssid;
    this.dwid = this.$route.query.dwid;
    var userde = this.$route.query.userde;
    if (userde === undefined || userde === null) {
    } else {
      this.USERDE = userde;
    }

    this.utilPost = this.$util.handler;
    //this.xmid = this.$route.query.xmid;
  },
  mounted() {
    var busData = {};
    var paramData = {
      headerData: {
        ssid: this.ssid,
        op: "wapGL", //反射名称1
        methodName: "getRmdTxfs", //对应的方法名
        USERDE: this.USERDE
      },
      busData: busData //参数内容
    };
    this.utilPost.paramData = paramData;
    this.utilPost.sendWritePost().then(data => {
      console.log(data);
      if (data.isSuccess) {
        this.RMDTXFS = data.content.RMDTXFS;
        this.SSMC = data.content.SSMC;
        if (this.RMDTXFS !== "TWOCODE" && this.RMDTXFS.length > 0) {
          this.mainData();
        } else {
          this.mainData();
        }
      } else {
        alert("名单获取失败：" + data.msg);
      }
    });
  },
  methods: {
    // 监听关闭事件
    handleClose() {
      if (!this.canClose) {
        // 阻止关闭，重新打开
        this.$nextTick(() => {
          this.showOverlay = true;
        });
      }
    },

    // 点击按钮关闭
    handleCloseClick() {
      this.canClose = true;
      this.showOverlay = false;
      // 重置状态
      this.$nextTick(() => {
        this.canClose = false;
      });
    },
    mainData() {
      var busData = {
        dwid: this.dwid,
        isWriteRmd: this.isWriteRmd,
        xmid: "",
        isksList: ["0"]
      };
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: "wapGL", //反射名称1
          methodName: "mainWriteData", //对应的方法名
          USERDE: this.USERDE
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendWritePost().then(data => {
        console.log(data);
        if (data.isSuccess) {
          this.resultListAll = data.content.DATALIST;
          this.fitterResultList(this.active, "");
          this.FZYSLIST = data.content.FZYSLIST;
          this.ISWRITEFZYS = data.content.ISWRITEFZYS;
          // this.ISJX = data.content.ISJX;
          // this.MJXCOUNT = data.content.MJXCOUNT;
          // this.WJXCOUNT = data.content.WJXCOUNT;
          // this.TEAMRMDLIST1 = data.content.TEAMRMDLIST1;
          // alert(JSON.stringify(this.TEAMRMDLIST1));
          // this.TEAMRMDLIST2 = data.content.TEAMRMDLIST2;
        } else {
          this.$notify({
            type: "danger",
            message: "名单获取失败：" + data.msg,
            duration: 6000
          });
        }
      });
    },
    onRefresh() {
      setTimeout(() => {
        this.mainData();
        this.isLoading = false;
      }, 500);
    },
    writeRmdSave(MXLIST, TYPE, CCH) {
      for (var i = 0; i < MXLIST.length; i++) {
        var TEAMRYID1 = MXLIST[i].TEAMRYID1;
        var TEAMRYID2 = MXLIST[i].TEAMRYID2;
        var TEAMRYID3 = MXLIST[i].TEAMRYID3;
        var TEAMRYID4 = MXLIST[i].TEAMRYID4;
        var LX = MXLIST[i].TEAMSSLX.substr(1, 2);

        if (TYPE === "L") {
          if (LX === "D") {
            if (TEAMRYID1.length === 0 || TEAMRYID2.length === 0) {
              this.$notify({
                type: "danger",
                message: "所有场次必须填写，请检查",
                duration: 6000
              });
              return;
            }
          } else {
            if (TEAMRYID1.length === 0) {
              this.$notify({
                type: "danger",
                message: "所有场次必须填写，请检查",
                duration: 6000
              });
              return;
            }
          }
        } else {
          if (LX === "D") {
            if (TEAMRYID3.length === 0 || TEAMRYID4.length === 0) {
              this.$notify({
                type: "danger",
                message: "所有场次必须填写，请检查",
                duration: 6000
              });
              return;
            }
          } else {
            if (TEAMRYID3.length === 0) {
              this.$notify({
                type: "danger",
                message: "所有场次必须填写，请检查",
                duration: 6000
              });
              return;
            }
          }
        }
      }

      Dialog.confirm({
        title: "提示",
        message: "请仔细核对填写的人名单，一旦提交，则无法再次修改!!!!!!"
      })
        .then(() => {
          var DATAS = [];

          for (var i = 0; i < MXLIST.length; i++) {
            var TEAMRYID1 = MXLIST[i].TEAMRYID1;
            var TEAMRYID2 = MXLIST[i].TEAMRYID2;
            var TEAMRYID3 = MXLIST[i].TEAMRYID3;
            var TEAMRYID4 = MXLIST[i].TEAMRYID4;
            var XMID = MXLIST[i].XMID;
            var SSID = MXLIST[i].SSID;
            var LX = MXLIST[i].TEAMSSLX.substr(1, 2);
            var LBHMX = MXLIST[i].LBH;
            var RBHMX = MXLIST[i].RBH;
            if (TYPE === "L") {
              if (LX === "D") {
                DATAS.push({
                  LBH: LBHMX[0],
                  CCH: CCH,
                  XMID: XMID,
                  LRYID: TEAMRYID1,
                  SSID: SSID
                });
                DATAS.push({
                  LBH: LBHMX[1],
                  CCH: CCH,
                  XMID: XMID,
                  LRYID: TEAMRYID2,
                  SSID: SSID
                });
              } else {
                DATAS.push({
                  LBH: LBHMX,
                  CCH: CCH,
                  XMID: XMID,
                  LRYID: TEAMRYID1,
                  SSID: SSID
                });
              }
            } else {
              if (LX === "D") {
                DATAS.push({
                  RBH: RBHMX[0],
                  CCH: CCH,
                  XMID: XMID,
                  RRYID: TEAMRYID3,
                  SSID: SSID
                });
                DATAS.push({
                  RBH: RBHMX[1],
                  CCH: CCH,
                  XMID: XMID,
                  RRYID: TEAMRYID4,
                  SSID: SSID
                });
              } else {
                DATAS.push({
                  RBH: RBHMX,
                  CCH: CCH,
                  XMID: XMID,
                  RRYID: TEAMRYID3,
                  SSID: SSID
                });
              }
            }
          }

          var busData = {
            XMID: MXLIST[0].XMID,
            CCH: CCH,
            WHOWRITE: TYPE,
            DATAS: DATAS,
            MXLIST: MXLIST
          };
          console.log(busData);

          var paramData = {
            headerData: {
              ssid: this.ssid,
              op: "wapGL", //反射名称1
              methodName: "wapSaveTeamRmd", //对应的方法名
              USERDE: this.USERDE
            },
            busData: busData //参数内容
          };
          this.utilPost.paramData = paramData;
          this.utilPost.sendWritePost().then(data => {
            this.$notify({
              type: "success",
              message: data.msg,
              duration: 6000
            });
            if (data.isSuccess) {
              this.generateImage().then(result => {
                this.DATAS = [];
                this.mainData();
              });
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    openDrop() {
      // alert("xx");
      // document.body.scrollTop = document.documentElement.scrollTop = 0;
    },
    dropDownChange(RYID, RYXM) {
      var MXITEM = this.selectRmdModel.MXITEM;
      var MXLIST = this.selectRmdModel.MXLIST;
      var TYPE = this.selectRmdModel.TYPE;
      var TEAMRMDLIST = this.selectRmdModel.TEAMRMDLIST;
      var ryidIndex = this.selectRmdModel.ryidIndex;

      switch (ryidIndex) {
        case 1: {
          MXITEM.TEAMRYID1 = RYID;
          MXITEM.TEAMRYXM1 = RYXM;
          break;
        }
        case 2: {
          MXITEM.TEAMRYID2 = RYID;
          MXITEM.TEAMRYXM2 = RYXM;
          break;
        }
        case 3: {
          MXITEM.TEAMRYID3 = RYID;
          MXITEM.TEAMRYXM3 = RYXM;
          break;
        }
        case 4: {
          MXITEM.TEAMRYID4 = RYID;
          MXITEM.TEAMRYXM4 = RYXM;
          break;
        }
        default: {
          this.$notify({
            type: "danger",
            message: "人员ID索引不存在",
            duration: 6000
          });
          this.selectRmdModel.isShow = false;
          return;
        }
      }

      var ISJX = MXITEM.ISJX;
      var SXH = MXITEM.SXH;
      var TEAMRYID1 = MXITEM.TEAMRYID1;
      var TEAMRYID2 = MXITEM.TEAMRYID2;
      var TEAMRYID3 = MXITEM.TEAMRYID3;
      var TEAMRYID4 = MXITEM.TEAMRYID4;
      var LX = MXITEM.TEAMSSLX.substr(1, 2);
      var XBLX = MXITEM.TEAMSSLX.substr(0, 1);

      if (TYPE === "L") {
        if (LX === "D") {
          if (
            TEAMRYID1 === TEAMRYID2 &&
            TEAMRYID1 !== "Retired0000000" &&
            TEAMRYID2 !== "Retired0000000"
          ) {
            MXITEM.TEAMRYID1 = "";
            MXITEM.TEAMRYID2 = "";
            this.$notify({
              type: "danger",
              message: "双打不能填写相同的运动员，请检查",
              duration: 6000
            });
            this.selectRmdModel.isShow = false;
            return;
          }
        }
      } else if (TYPE === "R") {
        if (LX === "D") {
          if (
            TEAMRYID3 === TEAMRYID4 &&
            TEAMRYID3 !== "Retired0000000" &&
            TEAMRYID4 !== "Retired0000000"
          ) {
            MXITEM.TEAMRYID3 = "";
            MXITEM.TEAMRYID4 = "";
            this.$notify({
              type: "danger",
              message: "双打不能填写相同的运动员，请检查",
              duration: 6000
            });
            this.selectRmdModel.isShow = false;
            return;
          }
        }
      } else {
        this.$notify({
          type: "danger",
          message: "类型不存在",
          duration: 6000
        });
        this.selectRmdModel.isShow = false;
        return;
      }
      if (ISJX === "0") {
        console.log("啦啦啦");
        //不允许兼项的时候
        var leftCount = 0;
        var leftRyidsArray = [];
        var rightCount = 0;
        var rightRyidsArray = [];
        for (var i = 0; i < MXLIST.length; i++) {
          var itemTEAMRYID1 = MXLIST[i].TEAMRYID1;
          var itemTEAMRYID2 = MXLIST[i].TEAMRYID2;
          var itemTEAMRYID3 = MXLIST[i].TEAMRYID3;
          var itemTEAMRYID4 = MXLIST[i].TEAMRYID4;
          var teamsslxEnd = MXLIST[i].TEAMSSLX.substr(1, 2);
          if (teamsslxEnd === "D") {
            if (TYPE === "L") {
              if (itemTEAMRYID1.length > 0) {
                leftCount++;
                if (leftRyidsArray.indexOf(itemTEAMRYID1) === -1) {
                  leftRyidsArray.push(itemTEAMRYID1);
                } else {
                  if (itemTEAMRYID1.indexOf("Retired") > -1) {
                    leftRyidsArray.push(itemTEAMRYID1);
                  }
                }
              }

              if (itemTEAMRYID2.length > 0) {
                leftCount++;
                if (leftRyidsArray.indexOf(itemTEAMRYID2) === -1) {
                  leftRyidsArray.push(itemTEAMRYID2);
                } else {
                  if (itemTEAMRYID2.indexOf("Retired") > -1) {
                    leftRyidsArray.push(itemTEAMRYID2);
                  }
                }
              }
            } else if (TYPE === "R") {
              if (itemTEAMRYID3.length > 0) {
                rightCount++;
                if (rightRyidsArray.indexOf(itemTEAMRYID3) === -1) {
                  rightRyidsArray.push(itemTEAMRYID3);
                } else {
                  if (itemTEAMRYID3.indexOf("Retired") > -1) {
                    rightRyidsArray.push(itemTEAMRYID3);
                  }
                }
              }

              if (itemTEAMRYID4.length > 0) {
                rightCount++;
                if (rightRyidsArray.indexOf(itemTEAMRYID4) === -1) {
                  rightRyidsArray.push(itemTEAMRYID4);
                } else {
                  if (itemTEAMRYID4.indexOf("Retired") > -1) {
                    rightRyidsArray.push(itemTEAMRYID4);
                  }
                }
              }
            } else {
              MXITEM.TEAMRYID1 = "";
              MXITEM.TEAMRYID2 = "";
              MXITEM.TEAMRYID3 = "";
              MXITEM.TEAMRYID4 = "";
              this.$notify({
                type: "danger",
                message: "填写方向未找到",
                duration: 6000
              });
              this.selectRmdModel.isShow = false;
              return;
            }
          } else if (teamsslxEnd === "S") {
            if (TYPE === "L") {
              if (itemTEAMRYID1.length > 0) {
                leftCount++;
                if (leftRyidsArray.indexOf(itemTEAMRYID1) === -1) {
                  leftRyidsArray.push(itemTEAMRYID1);
                } else {
                  if (itemTEAMRYID1.indexOf("Retired") > -1) {
                    leftRyidsArray.push(itemTEAMRYID1);
                  }
                }
              }
            } else if (TYPE === "R") {
              if (itemTEAMRYID3.length > 0) {
                rightCount++;
                if (rightRyidsArray.indexOf(itemTEAMRYID3) === -1) {
                  rightRyidsArray.push(itemTEAMRYID3);
                } else {
                  if (itemTEAMRYID3.indexOf("Retired") > -1) {
                    rightRyidsArray.push(itemTEAMRYID3);
                  }
                }
              }
            } else {
              MXITEM.TEAMRYID1 = "";
              MXITEM.TEAMRYID2 = "";
              MXITEM.TEAMRYID3 = "";
              MXITEM.TEAMRYID4 = "";
              this.$notify({
                type: "danger",
                message: "填写方向未找到",
                duration: 6000
              });
              this.selectRmdModel.isShow = false;
              return;
            }
          } else {
            MXITEM.TEAMRYID1 = "";
            MXITEM.TEAMRYID2 = "";
            MXITEM.TEAMRYID3 = "";
            MXITEM.TEAMRYID4 = "";
            this.$notify({
              type: "danger",
              message: "赛事类型未找到",
              duration: 6000
            });
            this.selectRmdModel.isShow = false;
            return;
          }
        }

        if (TYPE === "L") {
          if (leftCount != leftRyidsArray.length) {
            MXITEM.TEAMRYID1 = "";
            MXITEM.TEAMRYID2 = "";
            this.$notify({
              type: "danger",
              message: "项目不能兼项，请检查运动员名单",
              duration: 6000
            });
            this.selectRmdModel.isShow = false;
            return;
          }
        } else {
          if (rightCount != rightRyidsArray.length) {
            MXITEM.TEAMRYID3 = "";
            MXITEM.TEAMRYID4 = "";
            this.$notify({
              type: "danger",
              message: "项目不能兼项，请检查运动员名单",
              duration: 6000
            });
            this.selectRmdModel.isShow = false;
            return;
          }
        }
      }

      //允许兼项的时候，需要判断男生兼项和女生兼项 在服务器端判断
      var busData = {
        XMID: MXITEM.XMID,
        TYPE: TYPE,
        MXLIST: MXLIST
      };
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: "wapGL", //反射名称1
          methodName: "jxCheck", //对应的方法名
          USERDE: this.USERDE
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendWritePost().then(data => {
        if (data.isSuccess) {
          var MXLISTContent = data.content;
          for (var i = 0; i < this.resultList.length; i++) {
            var CCH = this.resultList[i].CCH;
            var MXCCH = MXLISTContent[0].CCH;
            if (CCH === MXCCH) {
              this.resultList[i].MXLIST = MXLISTContent;
              break;
            }
          }
        }
        if (!data.isSuccess) {
          MXITEM.TEAMRYID1 = "";
          MXITEM.TEAMRYID2 = "";
          MXITEM.TEAMRYID3 = "";
          MXITEM.TEAMRYID4 = "";
          this.$notify({
            type: "danger",
            message: data.msg,
            duration: 6000
          });
          this.selectRmdModel.isShow = false;
          return;
        }
      });
      this.selectRmdModel.isShow = false;
    },
    fitterResultList(name, title) {
      this.tabType = name;
      this.fitterTypeList();
    },
    fitterTypeList() {
      this.resultList = [];
      var resultListAll = this.resultListAll;
      if (this.tabType === "0") {
        //待填写
        for (var i = 0; i < resultListAll.length; i++) {
          var MXITEM = resultListAll[i].MXLIST[0];
          var WHOWRITE = MXITEM.WHOWRITE;
          var LQRMDCOUNT1 = MXITEM.LQRMDCOUNT1;
          var LQRMDCOUNT2 = MXITEM.LQRMDCOUNT2;
          if (WHOWRITE === "success") {
          } else {
            if (WHOWRITE === "L") {
              if (LQRMDCOUNT1 === 0) {
                this.resultList.push(resultListAll[i]);
              }
            } else {
              if (LQRMDCOUNT2 === 0) {
                this.resultList.push(resultListAll[i]);
              }
            }
          }
        }
      } else {
        for (var i = 0; i < resultListAll.length; i++) {
          var MXITEM = resultListAll[i].MXLIST[0];
          var WHOWRITE = MXITEM.WHOWRITE;
          var LQRMDCOUNT1 = MXITEM.LQRMDCOUNT1;
          var LQRMDCOUNT2 = MXITEM.LQRMDCOUNT2;
          if (WHOWRITE === "success") {
            this.resultList.push(resultListAll[i]);
          } else {
            if (WHOWRITE === "L") {
              if (LQRMDCOUNT1 > 0) {
                this.resultList.push(resultListAll[i]);
              }
            } else {
              if (LQRMDCOUNT2 > 0) {
                this.resultList.push(resultListAll[i]);
              }
            }
          }
        }
      }
    },
    openFzysModal(type, dataItem, czlx) {
      if (czlx !== type || type === "success" || this.active === "1") {
        return;
      }
      this.fzysIsShow = true;
      this.setValueItem = dataItem;
    },
    onSelectFzys(item) {
      confirm("注意:双方服装颜色不要相似，是否提交？");
      this.fzysIsShow = false;
      var WHOWRITE = this.setValueItem.MXLIST[0].WHOWRITE;
      for (var i = 0; i < this.setValueItem.MXLIST.length; i++) {
        if (WHOWRITE === "L") {
          this.setValueItem.MXLIST[i].FZYS1 = item.name;
        } else if (WHOWRITE === "R") {
          this.setValueItem.MXLIST[i].FZYS2 = item.name;
        }
      }
    },
    openSelectRmdHandler(MXITEM, MXLIST, TYPE, TEAMRMDLIST, ryidIndex) {
      for (var i = TEAMRMDLIST.length - 1; i >= 0; i--) {
        var value = TEAMRMDLIST[i].value;
        var text = TEAMRMDLIST[i].text;
        TEAMRMDLIST[i].msg = "";
        if (value.length === 0) {
          TEAMRMDLIST.splice(i, 1);
        }

        if (value.length === 0 || text === "请选择") {
          continue;
        }

        var arraySelect = [];

        for (var a = 0; a < MXLIST.length; a++) {
          var TEAMRYID1 = MXLIST[a].TEAMRYID1;
          var TEAMRYID2 = MXLIST[a].TEAMRYID2;
          var TEAMRYID3 = MXLIST[a].TEAMRYID3;
          var TEAMRYID4 = MXLIST[a].TEAMRYID4;
          var TEAMSSLXMC = MXLIST[a].TEAMSSLXMC;
          var XMBM = MXLIST[a].XMBM;
          if (TYPE === "L") {
            if (value === TEAMRYID1 || value === TEAMRYID2) {
              // alert(value + "|" + TEAMRYID1 + "|" + TEAMRYID2);
              arraySelect.push(XMBM.length === 0 ? TEAMSSLXMC : XMBM);
            }
          } else if (TYPE === "R") {
            if (value === TEAMRYID3 || value === TEAMRYID4) {
              arraySelect.push(XMBM.length === 0 ? TEAMSSLXMC : XMBM);
            }
          }
        }
        if (arraySelect.length === 0) {
          TEAMRMDLIST[i].msg = "";
        } else {
          TEAMRMDLIST[i].msg = "已选择(" + arraySelect.join(",") + ")";
        }
      }
      this.selectRmdModel.MXITEM = MXITEM;
      this.selectRmdModel.MXLIST = MXLIST;
      this.selectRmdModel.TYPE = TYPE;
      this.selectRmdModel.TEAMRMDLIST = TEAMRMDLIST;
      this.selectRmdModel.ryidIndex = ryidIndex;
      this.selectRmdModel.isShow = true;
    },

    async generateImage() {
      this.$toast.loading({ message: "生成中...", forbidClick: true });

      try {
        const element = this.$refs.captureArea;

        const canvas = await html2canvas(element, {
          useCORS: true,
          scale: 2,
          backgroundColor: "#ffffff",
          width: element.scrollWidth,
          height: element.scrollHeight
        });

        this.imageUrl = canvas.toDataURL("image/jpeg", 0.9);
        this.$toast.clear();
        this.showOverlay = true;
      } catch (error) {
        this.$toast.fail("生成失败");
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.van-cell {
  border-bottom: 1px solid rgb(235, 237, 240);
}
.van-dropdown-menu__title {
  color: red;
  font-weight: 600;
}
.van-overflow-hidden {
  overflow: auto !important;
}
.overlay-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  padding: 20px;
}

.tip {
  color: white;
  font-size: 16px;
  margin-bottom: 20px;
  background: rgba(0, 0, 0, 0.6);
  padding: 10px 20px;
  border-radius: 20px;
}

.long-image {
  max-width: 90%;
  max-height: 70%;
  border-radius: 8px;
}

.close-btn {
  position: absolute;
  top: 20px;
  right: 20px;
  color: white;
  font-size: 30px;
}
/deep/ .van-image__img {
  height: 90% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/WriteTeamRym/WriteTeamRym.vue